export class HyperPayModel {
    public id: string = '';
    public shopperResultUrl: string = '';
}
